'use strict';
var loadAsyncJS, readLdJSON, unescape;

unescape = require('./m_underscore_replacements').unescape;

loadAsyncJS = require('./m_loadAsyncJS');

readLdJSON = require('./m_readLdJSON').readLdJSON;

(function(gtm) {
  var cCookie, eCookie, gtmData, loadGTM;
  gtmData = readLdJSON('gtmData');
  cCookie = window.Cookie.get('c');
  eCookie = window.Cookie.get('e');
  if (gtmData.data) {
    try {
      gtm = JSON.parse(unescape(unescape(gtmData.data)));
    } catch (error) {}
  }
  if (cCookie !== null && eCookie !== null) {
    gtm.dl_user_id = cCookie;
    gtm.dl_email_sha256 = eCookie;
  }
  gtm.platform = gtmData.platform;
  window.dataLayer = [gtm];
  if (gtmData.enabled) {
    loadGTM = function() {
      var src;
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      src = new URL('https://www.googletagmanager.com/gtm.js');
      if (gtmData.id) {
        src.searchParams.set('id', gtmData.id);
      }
      return loadAsyncJS(src.toString());
    };
    return window.addEventListener('load', loadGTM, {
      passive: true,
      once: true
    });
  }
})({});

